module.exports = __webpack_public_path__ + "static/media/success.b02bd1d8.png";